module.exports = __webpack_public_path__ + "img/1step.bb31baaf.jpg";